import { Search } from '@api/api';
import { searchApiClient } from '@api/clients';
import { ActiveTabInfo, buildSearchFilter } from '@utils/search';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';

export const fetchSearch = async (
  query: string,
  tab?: ActiveTabInfo,
  pageParam?: number,
): Promise<{ data: Search }> => {
  const params = {
    _pages: {
      article: 0,
      collection: 0,
    },
    _filters: {},
  };

  if (!['collections', 'all'].includes(tab.name.toLowerCase())) {
    // eslint-disable-next-line no-underscore-dangle
    params._filters = {
      article: buildSearchFilter(tab.type, tab.filterValue),
    };
  }

  // eslint-disable-next-line no-underscore-dangle
  params._pages[tab.name.toLowerCase() === 'collections' ? 'collection' : 'article'] =
    pageParam ?? 0;

  const { data } = await searchApiClient.searchGet({ q: query }, { params });

  return { data };
};

export const useSearch = (
  query: string,
  tab: ActiveTabInfo,
): UseInfiniteQueryResult<{ data: Search }> => {
  return useInfiniteQuery(
    ['search', query, tab],
    (context) => fetchSearch(query, tab, context.pageParam),
    {
      getNextPageParam: ({
        data: {
          searchResults: { article, collection },
        },
      }) => {
        const { page, nbPages } = tab.name === 'collections' ? collection : article;
        return page + 1 < nbPages ? page + 1 : false;
      },
    },
  );
};
